import { render } from "./Recipe.vue?vue&type=template&id=77a35b92&scoped=true"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"

import "./Recipe.vue?vue&type=style&index=0&id=77a35b92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77a35b92"

export default script